import React from 'react';
import { Field } from '../final-form/react';
import { FormControlLabel } from '../Form';
import { Checkbox } from '../Checkbox';
import { Grid } from '../Grid';

function CheckboxesField(props) {
  const {
    input: {
      name,
      value,
      type,
      onChange,
      checked,
      ...restInput
    },
    label,
    helperText,
    meta,
    required,
    disabled,
    color,
    options,
    fullWidth, // does nothing here, strip from spread
    ...custom
  } = props;

  const evalValue = value || [];

  const onToggle = (opt) => () => {
    const alreadyChecked = evalValue.includes(opt);
    if (alreadyChecked) {
      onChange(evalValue.filter((item) => item !== opt));
    } else {
      onChange([...evalValue, opt]);
    }
  };

  return (
    <Field
      name={name}
      value={value}
      render={() => (
        <Grid container>
          {options.map((opt) => (
            <Grid item xs={12} key={opt.value}>
              <FormControlLabel
                control={(
                  <Checkbox
                    color={color}
                    inputProps={{ required, ...restInput }}
                  />
                )}
                label={opt.label}
                disabled={disabled}
                onChange={onToggle(opt.value)}
                checked={evalValue.includes(opt.value)}
                color={color}
                {...custom}
              />
            </Grid>
          ))}
        </Grid>
      )}
    />
  );
}

export default CheckboxesField;
